import { Events } from '|>/shared/events'
import { Intent } from '|>/shared/types/intent'
import { on, register } from '|>/shared/vjs'
import { BaseButton } from '../base'

import './play-next-episode.css'

/**
 * Play next button component
 */
@register
export class PlayNextEpisode extends BaseButton {
  @on(Events.Controls.ShowPlayNextEpisodeControl)
  changeVisibility(visible: Events.Controls.ShowPlayNextEpisodeControl) {
    if (visible) this.show()
    else this.hide()
  }

  override handleClick(event: MouseEvent) {
    event.stopPropagation()
    this.player_.trigger(Events.User.Intent, Intent.PlayNextEpisode)
    this.player_.trigger(Events.Player.PlayNextEpisode)
  }
}

PlayNextEpisode.options = {
  className: 'vjs-x-next-episode-button',
}
